'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../../../dist-es6/client/formatters');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ReportRasterScheduleDirective=function(_BaseControllerBacked){_inherits(ReportRasterScheduleDirective,_BaseControllerBacked);function ReportRasterScheduleDirective(){_classCallCheck(this,ReportRasterScheduleDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ReportRasterScheduleDirective,[{key:'objectBindings',get:function()
{
return[
'displayTimeZone',
'timezoneDescription',
'timeOfLastHosStatus',
'timezone',
'dailySchedules',
'personalSchedule',
'fatigueThreshold',
'now',
'timeOfLastScheduleUpdate',
'invalidDataWarning',
'predictedWorkday',
'forecastDutyInterval',
'weekFormatter',
'sleepFormatter',
'personalStatistics'];
}},{key:'templateUrl',get:function()

{
return'/templates/features/fatigueReport/components/reportRasterSchedule/reportRasterScheduleView';
}},{key:'controller',get:function()

{
return ReportRasterScheduleDirectiveController;
}}]);return ReportRasterScheduleDirective}(BaseControllerBackedDirective);let


ReportRasterScheduleDirectiveController=
function ReportRasterScheduleDirectiveController(displaySettingsService){_classCallCheck(this,ReportRasterScheduleDirectiveController);
this._use24HourTimeline=displaySettingsService.use24HourTimeline;

this.axisLabelFormatter=this._use24HourTimeline?Formatters.utcAxisTimeLabel_24Hour:
Formatters.utcAxisTimeLabel;
};


module.exports=ReportRasterScheduleDirective;
//# sourceMappingURL=reportRasterScheduleDirective.js.map
